import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputBulkUpload, InputFile, InputMultiline, InputSelect, Layout, InputPicklist, InputSwitch, InputUID } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './event-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import PersonalinfoModel from '../personalinfo/personalinfo-model';
import OwnerPicklist from '../owner/owner-picklist.component';
import MessagePicklist from '../message/message-picklist.component';
import SectionChecklist from '../section/section-checklist.component';
import PersonalinfoPicklist from '../personalinfo/personalinfo-picklist.component';
import PersonalinfoChecklist from '../personalinfo/personalinfo-checklist.component';
import EventList from './event-list.component';
import EventquizList from '../eventquiz/eventquiz-list.component';
import UserUpload from '../user/user-upload.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
    caption?: string;
    astemplate?: string;
}

interface IState {
    datarow: Model;
    datasetParticipant: Array<any>;
    errors: any;
    datarowMedia: any;
}

export default class EventEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            datasetParticipant: [],
            errors: null,
            datarowMedia: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }

    private onLoadMessagestart = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'messagestart': data?.id, 'messagestartCaption': data?.name || ''  }  });
    }
    
    private onLoadMessageend = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'messageend': data?.id, 'messageendCaption': data?.name || ''  }  });
    }
    
    private onLoadSection = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'section': data || [], 'sectionCaption': data?.length > 0? data[0].name + (data.length>1? ', ...': '') : ''}  });
    }
    
    private onLoadCustomer = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'customer': data?.id, 'customerCaption': data?.name || ''  }  });
    }
    
    private onLoadParticipant = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'participant': data || [], 'participantCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    }

    private onLoadAllParticipantUpload = (data: any) => {
        this.setState({ datasetParticipant: data });
    }

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{id:this.state.datarow.imageId, files: data, ref: Model.endPointMedia, field:'image'}}});
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }

    private onSaveParticipantUpload = async(data: any) => {
        if (this.state.datarow.participant.findIndex((d: any) => d.id === data.id))
            await this.state.datarow.participant.push(data)
        const dataParticipant = this.state.datarow.participant?.map((d: any) => new PersonalinfoModel(d));
        this.setState({ datarow: { ...this.state.datarow, 'participantCaption': dataParticipant?.length > 0? (dataParticipant[0].name) + (dataParticipant.length>1? ', ...': '') : ''}  });
    }

    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
       
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} caption={this.state.datarow.parent && 'Edit Event Section'} 
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onLoad={this.onLoad} onError={this.onError} disableCard>  
                
                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange} />
                        <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                        {AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                            <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                        </InputPicklist> 
                        }
                        {this.state.datarow.parent &&
                        <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                        }
                        <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} error={this.state.errors?.type} onChange={this.onChange} readOnly={this.state.datarow.parent}/>
                        <InputSelect name='viewstyle' label='View Style' value={this.state.datarow.viewstyle} options={Model.optionViewstyle} error={this.state.errors?.viewstyle} onChange={this.onChange} readOnly={this.state.datarow.parent}/>
                        <InputSwitch name='usecamera' label='Use Camera' value={this.state.datarow.usecamera} error={this.state.errors?.usecamera} onChange={this.onChange}/>
                        <InputSwitch name='extratime' label='Allow Extra Time' value={this.state.datarow.extratime} error={this.state.errors?.extratime} onChange={this.onChange}/>
                        {!this.state.datarow.parent && <>
                        <InputPicklist name='messagestart' label='Message to Send Invitation' value={this.state.datarow.messagestart} caption={this.state.datarow.messagestartCaption} clearValue={this.onLoadMessagestart} error={this.state.errors?.messagestart} onChange={this.onChange} >
                            <MessagePicklist currentId={this.state.datarow.messagestart} onLoad={this.onLoadMessagestart} astemplate='yes'/>
                        </InputPicklist>
                        <InputPicklist name='messageend' label='Message to Send Result' value={this.state.datarow.messageend} caption={this.state.datarow.messageendCaption} clearValue={this.onLoadMessageend} error={this.state.errors?.messageend} onChange={this.onChange} >
                            <MessagePicklist currentId={this.state.datarow.messageend} onLoad={this.onLoadMessageend} astemplate='yes'/>
                        </InputPicklist>
                        </>}
                        <InputPicklist name='section' label='Section' value={this.state.datarow.section} caption={this.state.datarow.sectionCaption} disableAutoClose clearValue={this.onLoadSection} error={this.state.errors?.section} onChange={this.onChange} readOnly={this.state.datarow.parent}>
                            <SectionChecklist history={this.props.history} currentId={this.state.datarow.section} tag='quiz' onLoad={this.onLoadSection} disableBackButton/>
                        </InputPicklist> 
                        {!this.state.datarow.parent &&
                        <InputPicklist name='customer' label='Customer' value={this.state.datarow.customer} caption={this.state.datarow.customerCaption} error={this.state.errors?.customer} clearValue={this.onLoadCustomer} onChange={this.onChange} >
                            <PersonalinfoPicklist currentId={this.state.datarow.customer} onLoad={this.onLoadCustomer}/>
                        </InputPicklist>
                        }
                        <InputPicklist name='participant' label='Participant' value={this.state.datarow.participant} caption={this.state.datarow.participantCaption} disableAutoClose clearValue={this.onLoadParticipant} error={this.state.errors?.participant} onChange={this.onChange} readOnly={this.state.datarow.parent}>
                            <PersonalinfoChecklist history={this.props.history} caption='Select Participant' personalinfotypeType='customer' currentId={this.state.datarow.participant} onLoad={this.onLoadParticipant} disableBackButton/>
                        </InputPicklist> 
                        {!this.state.datarow.parent &&
                        <InputBulkUpload name='participantupload' label='Upload Participants (CSV)' onLoad={this.onLoadAllParticipantUpload} >
                            <UserUpload history={this.props.history} caption='Upload Participants (CSV)' onSave={this.onSaveParticipantUpload} dataset={this.state.datasetParticipant} disableBackButton/>
                        </InputBulkUpload>
                        }
                        <InputDate name='startdate' label='Start Date' value={this.state.datarow.startdate} clearValue error={this.state.errors?.startdate} onChange={this.onChange} />
                        <InputDate name='enddate' label='End Date' value={this.state.datarow.enddate} clearValue error={this.state.errors?.enddate} onChange={this.onChange} />
                        <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                        <InputUID name='uid' label='QR Code' value={this.state.datarow.uid} error={this.state.errors?.uid} link={window.location.origin + Model.url + '/'} onChange={this.onChange} />
                    </>
                    },

                    {caption: 'Sections', child: 
                    this.state.datarow.id > 0 && this.props.history && this.state.datarow.eventquizLength === 0 &&
                        <EventList history={this.props.history} root={this.props.root} caption='Event Section' parentId={this.state.datarow.id} disableBackButton disableCard/>
                    },
                    
                    {caption: 'Questions', child: 
                    this.state.datarow.id > 0 && this.props.history && this.state.datarow.eventquizLength > 0 &&
                        <EventquizList history={this.props.history} root={this.props.root} caption='Question' eventId={this.state.datarow.id} disableBackButton disableCard/>
                    },
                ]}
                />            
            
            </BaseEdit>
        )
    }
}